<template>
    <div style="width: 100%; height: 100%">
        <v-divider></v-divider>
        <div style="width: 100%" class="d-flex justify-end align-start mt-4">
            <v-btn
                class="mr-4"
                v-if="record.output.arupComputeReport_HTML"
                @click="genhtml"
                variant="elevated"
            >
                HTML
                <v-icon right class="ml-2">mdi-tray-arrow-down</v-icon>
            </v-btn>
            <div class="mr-4">
                <PdfButton :record="record" :text="false" :maxWidth="false" />
            </div>
            <v-btn
                color="primary"
                :disabled="!record.output.arupComputeReport_HTML"
                @click="openModal"
                variant="elevated"
            >
                Open
                <v-icon right class="ml-2">mdi-arrow-up-right</v-icon>
            </v-btn>
            <Dialog
                :report="true"
                :body="record.output"
                v-model="quickReport"
                :key="modalKey"
            />
            <!-- Include the key to force the dialog to refresh when the report changes -->
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import Dialog from './Dialog.vue'
import PdfButton from '../shared/PdfButton.vue'

const store = useStore()
const props = defineProps(['record'])

const quickReport = ref(false)
const modalKey = ref(0)

async function genhtml() {
    props.record.showProgress = true
    store.dispatch('printHtml', props.record)
    props.record.showProgress = false
}

function openModal() {
    modalKey.value++
    quickReport.value = true
}
</script>
<style scoped>
:deep(.v-btn--disabled.v-btn--variant-elevated) {
    background-color: #e0e0e0 !important;
    color: #757575 !important;
}
</style>
